import { getTranslation } from '../../../assets/creator/translations';
import { getCreatorAddresses } from './creatorAddresses';

export const versionRedirect = (address) => {
    const href = address.value || "";
    // Check if dev version
    if(window.location.hostname !== "localhost") {
        window.location.replace(`${href}`);
    } else {
        alert(`Redirect to ${href}`);
        window.location.replace(`${href}`); 
    }
}

export const getCurrentVersion = () => {
    const href = window.location.href;
    let element = null;
    // Check if dev version
    if(window.location.hostname !== "localhost") {
        getCreatorAddresses(getTranslation).forEach(function(x) {
            if(x.value === href) {
                element = x;
            }
            return element;
        });
    } else {
        return {label: 'develop', value: href};
    }
    return element;
}